var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 32,
    viewBox: "0 0 72 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.9953 0.0210876V11.2638C52.1076 9.85323 49.7843 9.02351 47.2535 9.02351C41.0303 9.02351 36.0103 14.064 36.0103 20.2662C36.0103 22.7968 36.84 25.1408 38.2714 27.0076C40.325 29.7457 43.5818 31.5088 47.2743 31.5088H54.0161V27.0076H47.2743C43.5611 27.0076 40.5325 23.9792 40.5325 20.2662C40.5325 16.5325 43.5611 13.5247 47.2743 13.5247C51.0082 13.5247 54.0161 16.5532 54.0161 20.2662V27.0076H58.5175V0.0210876H53.9953Z",
    fill: "#22262B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0001 27.0066H62.9998V31.5078H72.0001V27.0066Z",
    fill: "#004BFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2433 27.0073V31.5085C7.57158 31.5085 4.29402 29.7453 2.24036 27.0073C2.17812 26.9243 2.11589 26.8413 2.05366 26.7376C0.746784 24.9123 0 22.672 0 20.2451V0H4.50146V20.2451C4.48071 23.9788 7.50934 27.0073 11.2433 27.0073Z",
    fill: "#22262B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.249 9.00244V11.2634C27.3613 9.8529 25.038 9.02318 22.5072 9.02318C16.284 9.02318 11.2639 14.0637 11.2639 20.2658C11.2639 22.7965 12.0937 25.1404 13.525 27.0073C15.5787 29.7454 18.8355 31.5085 22.5279 31.5085H29.2697V27.0073H22.5279C18.8147 27.0073 15.7861 23.9788 15.7861 20.2658C15.7861 16.5321 18.8147 13.5244 22.5279 13.5244C26.2619 13.5244 29.2697 16.5529 29.2697 20.2658V27.0073H33.7712V9.00244H29.249Z",
    fill: "#22262B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlack);
export default __webpack_public_path__ + "static/media/logo_black.f1fc76aa884372150f2707b09fe26bf8.svg";
export { ForwardRef as ReactComponent };